import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Link } from "react-router-dom";

import image from "../assets/images/home-image.png";

export default function Home({ mobile }) {
	const { signIn } = useAuth();
	return (
		<div className="home">
			<div className="home-presentation">
				<div className="home-content">
					<h1 className="home-title">myAutomata</h1>
					<h2 className="home-description">
						Diseñador online para crear y compartir autómatas finitos.
						
						<br />
						Soporte para autómatas finitos determinísticos y no
						determinísticos. <br />
						Guarda tus autómatas en la nube para compartirlos y
						editarlos en cualquier lugar.
					</h2>
				</div>
				{mobile ? 
				<div className="actions">
					<p className="text-4">
						Actualmente no es posible utilizar el editor en dispositivos móviles.
					</p>
				</div>:
				<div className="actions">
					<div className="flex-center">
						<button className="action-button" onClick={signIn}>
							Iniciar sesión
						</button>
						<Link
							style={{ marginLeft: "20px" }}
							className="success-button"
							to="/editor"
						>
							Comenzar a crear
						</Link>
					</div>
					<div></div>
				</div>
				}
			</div>
			<div className="home-image">
				<img src={image} alt="" className="home-automata" />
			</div>
		</div>
	);
}
